import memoize from 'lodash/memoize';
import { useUserLookupStore } from '../store/use-user-lookup-store';
export function useUser(userId) {
    const lookupUser = useUserLookupStore((s) => s.lookupUser);
    return userId ? lookupUser(userId) ?? getStableDefault(userId) : undefined;
}
const getStableDefault = memoize((userId) => {
    return {
        userId,
        username: '',
        usernameConfirmed: true,
        usernameEncrypted: false,
        displayName: '',
        displayNameEncrypted: false,
    };
}, (userId) => userId);
//# sourceMappingURL=use-user.js.map